import * as stagesSettlement from "../../Stages/StagesSettlement";

import { Settlement } from "../../../types/Products/EmploymentLaw/Settlement";

export const settlementRequiredFields = {
  [stagesSettlement.STAGE_INCOMPLETE]: (settlement: Settlement) => {
    return [];
  },
  [stagesSettlement.STAGE_READY]: (settlement: Settlement) => {
    return [];
  },
  [stagesSettlement.STAGE_CHECKED]: (settlement: Settlement) => {
    let requiredFields = [
      "contractTerminationDate",
      "lastWorkDayCalculated",
      "lastWorkDayCancellation",
      "contractDate",
      "bargainingCoverage",
      "employerOrganization.legalForm",
      "employerOrganization.name",
      //needed for court crawler
      "employerOrganization.address.postalCode",
      "paymentType",
      "terminationType",
      "responsibleCourt",
      "employedSince",
    ];

    if (!["natürliche Person", "__null__"].includes(settlement.employerOrganization.legalForm ?? "")) {
      requiredFields.push("representedBy");
    }

    if (settlement.legalExpenseInsurance) {
      requiredFields.push("caseInsurance.deductible", "caseInsurance.insurer", "caseInsurance.insurancePolicyNumber");
    }

    return requiredFields;
  },
  [stagesSettlement.STAGE_SUBMITTED]: (settlement: Settlement) => {
    return ["client.birthDate"];
  },
  [stagesSettlement.STAGE_PAID]: (settlement: Settlement) => {
    let requiredFields = [];
    if (settlement.legalExpenseInsurance) {
      requiredFields.push("insuranceCoverageDate");
    }
    return requiredFields;
  },
  [stagesSettlement.STAGE_DATE_SET_SETTLEMENT]: (settlement: Settlement) => {
    return ["courtReference"];
  },
  [stagesSettlement.STAGE_DATE_SET_TRIAL]: (settlement: Settlement) => {
    return [];
  },
  [stagesSettlement.STAGE_DECISION_MADE]: (settlement: Settlement) => {
    return [];
  },
  [stagesSettlement.STAGE_COMPLETED]: (settlement: Settlement) => {
    let requiredFields = [];
    if (settlement.legalExpenseInsurance) {
      requiredFields.push("insuranceCoverageDate");
    }
    return requiredFields;
  },
};
